module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('p', {
    staticClass: "imagec"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_8"
    }
  }, [_c('img', {
    staticClass: "in18",
    attrs: {
      "alt": "image",
      "src": "images/ch01.gif"
    }
  })])]), _vm._v(" "), _c('h2', {
    staticClass: "h2c"
  }, [_vm._v("Chapter One:")]), _vm._v(" "), _c('h2', {
    staticClass: "h2d"
  }, [_vm._v("WHAT IS THE KETOGENIC DIET?")]), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_vm._v("For decades, we’ve been given the wrong advice: Eat less, avoid dietary fats, and exercise more. Today, carbohydrates constitute the majority of our diet, and that has significant implications for hormone balance. Insulin, which is also responsible for storing fat in our bodies, is greatly affected by excessive carbohydrate consumption. And that means that carbohydrates are, without doubt, the most fattening element in our diets.")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_9"
    }
  }, [_vm._v("Yet, the standard dietary guidelines most of us are familiar with advise that we follow a high-carb, moderate-protein, and low-fat diet (45% to 65% calories from carbohydrates, 10% to 35% calories from protein, and 20% to 35% calories from fat). Contrary to these macronutrient recommendations, the ketogenic diet is high in fat, moderate in protein, and low in carbs. The macronutrient ratio in terms of calories typically sits within the following ranges:")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentsa"
  }, [_vm._v("60% to 75% (or even more) of calories from fat")]), _vm._v(" "), _c('p', {
    staticClass: "noindentsa"
  }, [_vm._v("15% to 30% of calories from protein")]), _vm._v(" "), _c('p', {
    staticClass: "noindentsa"
  }, [_vm._v("5% to 10% of calories from carbs")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("With this macronutrient intake, the ketogenic diet achieves weight loss and health benefits by inducing a metabolic state known as ketosis, which is usually achieved at a level of about 50 grams of total carbohydrates a day (20 to 30 grams of net carbohydrates). Ketosis causes the liver to produce ketone bodies—molecules created by the body for energy during periods of fasting or carbohydrate restriction—which shifts the body’s metabolism away from glucose (the primary energy source derived from carbs) and toward burning fat.")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("One significant health benefit of the ketogenic diet is that it enhances the individual’s ability to build and preserve muscle tissue. And it’s not only an effective weight-loss tool; it’s also been shown to improve several health conditions, such as diabetes, Alzheimer’s, Parkinson’s, epilepsy, and even cancer.")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("A comparison of several scientific trials shows that low-carb diets outperform calorie-restricted diets in terms of long-term weight loss and lasting health effects. Restricting carbohydrates is a very effective way of controlling appetite, which explains why so many people successfully lose weight on a low-carb diet. Again, the key factor is insulin. It’s released when you eat carbs, and it affects your appetite: eating fewer carbs means you’ll experience fewer cravings.")]), _vm._v(" "), _c('div', {
    staticClass: "land100"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0009-01.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('h3', {
    staticClass: "h3"
  }, [_vm._v("DO WE REALLY NEED CARBS?")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("A common misconception is that our bodies—especially our brains—need glucose. However, apart from some basic metabolic functions that need glucose exclusively, our bodies can use "), _c('em', [_vm._v("either")]), _vm._v(" glucose or ketones for energy: in fact, glucose is nowhere near as efficient as ketone bodies. Provided you eat enough protein, your body can produce glucose for its basic metabolic functions on demand via a process called "), _c('em', [_vm._v("gluconeogenesis")]), _vm._v(", in which it transforms noncarbohydrate sources, such as amino acids (proteins) and fatty acids (fats), into glucose.")])]), _vm._v(" "), _c('h3', {
    staticClass: "h3a"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_10"
    }
  }, [_vm._v("THE KETODIET APPROACH")])]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("The KetoDiet approach is simple: It’s a low-carb diet with a focus on eating "), _c('em', [_vm._v("real")]), _vm._v(" food.")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("With the growing popularity of low-carb diets, the food industry introduced many new low-carb convenience foods. While such foods may indeed be low in carbs, they’re often laden with unhealthy ingredients, such as artificial sweeteners, preservatives, and other additives. You won’t find any of these things in my recipes—and you won’t find grains, sugar, potatoes, legumes, or unhealthy oils in them, either. (But you will find dairy-free options in a number of my recipes.)")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("For the ketogenic diet to yield the best results, tracking your food intake is highly recommended, since it’s very easy to go over your carb limit if you’re new to this way of eating. My recipes contain detailed nutritional information so you can easily track your food intake, especially carbs. Ideally, you’ll plan your daily meals in advance, and you’ll be aware of all carbs you consume. Remember, it’s not okay to have a piece of cake, a bag of chips, or a bowl of pasta—"), _c('em', [_vm._v("especially")]), _vm._v(" not at the beginning of the diet. Yes, it will be hard for the first couple of weeks, but the results will be more than rewarding!")]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('h3', {
    staticClass: "h3"
  }, [_vm._v("THE BASIC PRINCIPLES")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("As you learn more about keto-friendly foods and get used to ketogenic/low-carb living, it’ll be easier for you to understand what and how much you should be eating. Here’s a crash course in what your daily macronutrient—carbs, protein, and fat—should look like.")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('h4', {
    staticClass: "h4"
  }, [_vm._v("Carbohydrates (5% to 10% of Your Daily Energy Requirements)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Each person’s carb tolerance is different. Your challenge is to find your “ideal” carb intake. As you begin your KetoDiet, start with a low level of net carbs to ensure you quickly enter ketosis—the state in which your body produces ketone bodies. A good goal would be about 20 grams of net carbs per day. You can purchase a blood ketone meter (or urine ketone strips, which are less accurate) that will allow you to measure your ketones after about two or three days of sticking to your new low-carb lifestyle. Start adding net carbs (about 5 grams each week) until you detect a very low level of ketones or none at all. This is usually the quickest, most reliable way to discover your net carbs limit. You can find blood ketone meters and urine ketone strips via online retailers, such as Amazon.")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('h5', {
    staticClass: "h5"
  }, [_vm._v("Total Carbs or Net Carbs?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("To follow a low-carb, ketogenic diet, you can limit either your total carb intake or your net carb intake. Net carbs are total carbs without fiber.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Most people who follow a ketogenic diet stay below 20 to 30 grams of net carbs or 50 grams of total carbs, as recommended by physicians Jeff Volek and Stephen Phinney, authors of "), _c('em', [_vm._v("The Art and Science of Low Carbohydrate Living")]), _vm._v(". It’s up to you which path you choose.")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("And, although some people fear that fiber raises blood sugar, recent studies show that fiber may actually reduce it.")]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('h5', {
    staticClass: "h5"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_11"
    }
  }, [_vm._v("Keto-Flu and the Importance of Electrolytes")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("No matter how old you are, your body is probably used to sugar and glucose at this point in your life. Excluding it from your diet may lead to headaches, weakness, or fatigue during the first few days of your new ketogenic lifestyle. These symptoms—sometimes referred to as “keto flu”—should dissipate after a few days or weeks. Increasing your intake of electrolytes (sodium, magnesium, and potassium) can minimize these negative side effects. Try my homemade Bone Broth ("), _c('a', {
    attrs: {
      "href": "#/xhtml/ch02#recipe8"
    }
  }, [_vm._v("here")]), _vm._v(") and eat foods high in electrolytes, such as avocados, nuts, fatty fish, dark leafy greens, spinach, and mushrooms.")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('h4', {
    staticClass: "h4"
  }, [_vm._v("Protein (15% to 30% of Your Daily Energy Requirements)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The amount of dietary protein you need can be determined by your body weight and activity level. People who are physically active have higher protein requirements than those with sedentary lifestyles. A more accurate estimate, especially for people with high body fat, can be reached by calculating protein intake from lean mass, which is calculated as total body weight minus body fat.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Eating enough protein is important for preserving and building muscle mass, but eating excessive amounts of protein is likely to put you out of ketosis because your body will convert excessive protein into glycogen.")]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('h5', {
    staticClass: "h5"
  }, [_vm._v("How Many Grams of Protein per Day?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("If your weight is in pounds, multiply it by 0.6 to get the minimum amount of protein in grams you should eat each day. For the maximum, multiply your body weight by 1 (i.e., the same numeral as that of your weight). If your weight is in kilograms, simply multiply it by 1.3 and 2.2 to get the same range. Although this rule applies to the majority of people, protein requirements for athletes are higher.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Make sure you eat at least the minimum amount of protein to prevent loss of muscle tissue during the diet. In general, the more active you are, the closer you should be eating to your upper limit.")]), _vm._v(" "), _c('div', {
    staticClass: "land60"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0011-01.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('h4', {
    staticClass: "h4"
  }, [_vm._v("Fat (60% to 75% of Your Daily Energy Requirements)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Your daily fat intake should make up your remaining energy needs: it acts as “filler” for your energy requirements. Ideal fat intake varies for each individual and depends on your personal goal. In general, you won’t need to precisely count fat intake or calories on a ketogenic diet, as you’ll be unlikely to overeat: eating foods naturally low in carbs, moderate in protein, and high in fat will keep you satiated for longer. Studies have shown that protein and fats are the most satiating nutrients, while carbohydrates are the least satiating. Fat provides a steady supply of energy with no insulin spikes. That’s why you won’t experience any cravings or energy and mood swings as you would on a calorie-restricted, low-fat diet.")])]), _vm._v(" "), _c('div', {
    staticClass: "sidebar"
  }, [_c('p', {
    staticClass: "stitle"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_12"
    }
  }, [_vm._v("HEALTHY OILS AND FATS")])]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Since you’ll be increasing your fat intake, it’s critical to understand which fats are beneficial and which may damage your health. Not all fats are created equal: simply put, the type and quality of fats matter. Follow these rules when you’re choosing oils and fats:")]), _vm._v(" "), _c('p', {
    staticClass: "ulist"
  }, [_vm._v("• Use oils and fats high in saturated fats for all cooking (pure pastured lard, ghee, butter, grass-fed beef tallow, coconut oil, cacao butter, and red palm oil). Use extra virgin coconut oil, which is high in medium-chain triglycerides (MCTs) or try pure MCT oil for extra-effective fat-burning.")]), _vm._v(" "), _c('p', {
    staticClass: "ulist"
  }, [_vm._v("• Use oils and fats high in monounsaturated fats for light cooking and in salads (extra virgin olive oil, avocado oil, and macadamia nut oil).")]), _vm._v(" "), _c('p', {
    staticClass: "ulist"
  }, [_vm._v("• Use oils and fats high in polyunsaturated fats only in salads and for other cold uses. Oils high in polyunsaturated fats are nut and seed oils, like walnut, almond, hazelnut, flaxseed, or pumpkin seed oil. Increase your intake of omega-3 fatty acids, especially from animal sources, and avoid using too many oils high in omega-6 fatty acids (sesame oil, almond oil, etc.).")]), _vm._v(" "), _c('p', {
    staticClass: "ulist"
  }, [_vm._v("• Never use unhealthy fats like margarine, sunflower, rapeseed/canola, safflower, soy, cottonseeds, or grapeseed. All these are either processed, genetically-modified oils, or have a very unhealthy omega-6 to omega-3 ratio.")])]), _vm._v(" "), _c('div', {
    staticClass: "land80"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0012-01.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('h4', {
    staticClass: "h4"
  }, [_vm._v("Do Calories Count?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Well, yes. It’s a common misconception that you can eat an unlimited amount of calories and still lose weight. In fact, you can put on weight even on a low-carb diet. Although this doesn’t happen often, understanding a few basic principles will help you avoid common mistakes.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Low-carb ketogenic diets are naturally satiating and act as appetite suppressants. This is why you’ll eat less and won’t need to count calories. However, if your weight is stalling for more than two to three weeks, you may need to consider keeping an eye on your energy intake.")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("That said, hitting a weight-loss plateau may be caused by a number of reasons. You don’t necessarily have to be eating too much: in fact, you may discover that you haven’t been eating enough. Avoiding sweeteners and abstaining from snacking between meals may also help you break through a plateau. And, in my experience, losing body fat becomes more difficult as you get closer to your target weight.")]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('h3', {
    staticClass: "h3"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_13"
    }
  }, [_vm._v("THE KETODIET A NUTSHELL")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Here’s a handy reference to use as you begin your new KetoDiet lifestyle:")])]), _vm._v(" "), _c('p', {
    staticClass: "ulist"
  }, [_vm._v("• Stick with the keto ratio: 60% to 75% of calories from fat, 15% to 30% calories from protein, and 5% to 10% calories from net carbs.")]), _vm._v(" "), _c('p', {
    staticClass: "ulist"
  }, [_vm._v("• Get your daily net carbs (total carbs without fiber) down to less than 50 grams, preferably to 20 to 30 grams.")]), _vm._v(" "), _c('p', {
    staticClass: "ulist"
  }, [_vm._v("• Keep your protein intake moderate (0.6 to 1 g per pound, or 1.3 to 2.2 g per kilogram of lean body mass).")]), _vm._v(" "), _c('p', {
    staticClass: "ulist"
  }, [_vm._v("• Eat more healthy fats (saturated, omega 3s, and monounsaturated).")]), _vm._v(" "), _c('p', {
    staticClass: "ulist"
  }, [_vm._v("• Eat when you’re hungry, even if it’s only a meal a day. You don’t have to limit quantities of food deliberately, but you should stop eating when you feel full.")]), _vm._v(" "), _c('p', {
    staticClass: "ulist"
  }, [_vm._v("• Don’t count calories. Your diet will be naturally satiating.")]), _vm._v(" "), _c('p', {
    staticClass: "ulist"
  }, [_vm._v("• Drink more water.")]), _vm._v(" "), _c('p', {
    staticClass: "ulist"
  }, [_vm._v("• Beware of hidden carbs and unhealthy ingredients. Always read the labels.")]), _vm._v(" "), _c('p', {
    staticClass: "ulist"
  }, [_vm._v("• Avoid eating anything labeled “low-fat” or “fat-free.” Focus on eating real food, like meat, eggs, nonstarchy vegetables, and whole dairy.")]), _vm._v(" "), _c('p', {
    staticClass: "ulist"
  }, [_vm._v("• Don’t trust products labeled “low-carb.” Instead, focus on foods that are naturally low in carbs.")]), _vm._v(" "), _c('p', {
    staticClass: "ulist"
  }, [_vm._v("• Up your electrolytes (sodium, magnesium, and potassium). Include avocados, nuts, and leafy greens in your diet. Take supplements if needed.")]), _vm._v(" "), _c('p', {
    staticClass: "ulist"
  }, [_vm._v("• Be prepared: plan your diet in advance to avoid “accidents.” Keep motivated and focus on your targets!")]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('h3', {
    staticClass: "h3"
  }, [_vm._v("THE KETODIET FOOD LIST")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Use the following information as your guidelines for healthy eating on the KetoDiet.")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('h4', {
    staticClass: "h4"
  }, [_vm._v("Eat Freely")]), _vm._v(" "), _c('h5', {
    staticClass: "h5a"
  }, [_vm._v("Grass-Fed and Wild Animal Sources")]), _vm._v(" "), _c('p', {
    staticClass: "ulist"
  }, [_vm._v("– grass-fed meat (beef, lamb, goat, and venison): Avoid sausages and meat covered in breadcrumbs, hot dogs, and meat that comes with sugary or starchy sauces.")])]), _vm._v(" "), _c('p', {
    staticClass: "ulist"
  }, [_vm._v("– wild-caught fish and seafood")]), _vm._v(" "), _c('p', {
    staticClass: "ulist"
  }, [_vm._v("– pastured pork and poultry")]), _vm._v(" "), _c('p', {
    staticClass: "ulist"
  }, [_vm._v("– pastured eggs")]), _vm._v(" "), _c('p', {
    staticClass: "ulist"
  }, [_vm._v("– gelatin")]), _vm._v(" "), _c('p', {
    staticClass: "ulist"
  }, [_vm._v("– ghee and butter")]), _vm._v(" "), _c('p', {
    staticClass: "ulist"
  }, [_vm._v("– offal, grass-fed (liver, heart, kidneys, and other organ meats)")]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('h5', {
    staticClass: "h5"
  }, [_vm._v("Healthy Fats")]), _vm._v(" "), _c('p', {
    staticClass: "ulist"
  }, [_vm._v("– saturated (pure pastured lard, grass-fed beef tallow, chicken fat, duck fat, goose fat, clarified butter/ghee, butter, and coconut oil)")])]), _vm._v(" "), _c('p', {
    staticClass: "ulist"
  }, [_vm._v("– monounsaturated (avocado, macadamia, and olive oil)")]), _vm._v(" "), _c('p', {
    staticClass: "ulist"
  }, [_vm._v("– polyunsaturated omega 3s, especially from animal sources (fatty fish and seafood)")]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('h5', {
    staticClass: "h5"
  }, [_vm._v("Nonstarchy Vegetables")]), _vm._v(" "), _c('p', {
    staticClass: "ulist"
  }, [_vm._v("– leafy greens (Swiss chard, bok choy, spinach, lettuce, chard, chives, endive, radicchio, etc.)")])]), _vm._v(" "), _c('p', {
    staticClass: "ulist"
  }, [_vm._v("– some cruciferous vegetables (kale, kohlrabi, and radishes)")]), _vm._v(" "), _c('p', {
    staticClass: "ulist"
  }, [_vm._v("– celery stalks, asparagus, cucumber, summer squash, zucchini, spaghetti squash, and bamboo shoots")]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('h5', {
    staticClass: "h5"
  }, [_vm._v("Fruits, Nuts, and Seeds")]), _vm._v(" "), _c('p', {
    staticClass: "ulist"
  }, [_vm._v("– avocado")])]), _vm._v(" "), _c('p', {
    staticClass: "ulist"
  }, [_vm._v("– coconut")]), _vm._v(" "), _c('p', {
    staticClass: "ulist"
  }, [_vm._v("– macadamia nuts")]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('h5', {
    staticClass: "h5"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_14"
    }
  }, [_vm._v("Beverages and Condiments")])]), _vm._v(" "), _c('p', {
    staticClass: "ulist"
  }, [_vm._v("– water, coffee (black or with cream or coconut milk), tea (black or herbal)")])]), _vm._v(" "), _c('p', {
    staticClass: "ulist"
  }, [_vm._v("– pork rinds (cracklings) for “breading”")]), _vm._v(" "), _c('p', {
    staticClass: "ulist"
  }, [_vm._v("– mayonnaise, mustard, pesto, bone broth, pickles, and fermented foods (kimchi, kombucha, and sauerkraut)—best when they’re homemade with no additives")]), _vm._v(" "), _c('p', {
    staticClass: "ulist"
  }, [_vm._v("– all spices and herbs, and lemon or lime juice and zest")]), _vm._v(" "), _c('p', {
    staticClass: "ulist"
  }, [_vm._v("– whey protein (beware of additives, artificial sweeteners, hormones, and soy lecithin), egg white protein, and gelatin (grass-fed, hormone-free)")]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('h4', {
    staticClass: "h4"
  }, [_vm._v("Eat Occasionally")]), _vm._v(" "), _c('h5', {
    staticClass: "h5a"
  }, [_vm._v("Vegetables, Mushrooms, and Fruits")]), _vm._v(" "), _c('p', {
    staticClass: "ulist"
  }, [_vm._v("– some cruciferous vegetables (white and green cabbage, red cabbage, cauliflower, broccoli, brussels sprouts, fennel, turnips, and rutabaga)")])]), _vm._v(" "), _c('p', {
    staticClass: "ulist"
  }, [_vm._v("– nightshades (eggplant, tomatoes, and peppers)")]), _vm._v(" "), _c('p', {
    staticClass: "ulist"
  }, [_vm._v("– some root vegetables (parsley root), spring onion, leek, onion, garlic, mushrooms, and winter squash (pumpkin)")]), _vm._v(" "), _c('p', {
    staticClass: "ulist"
  }, [_vm._v("– sea vegetables (nori and kombu), okra, bean sprouts, sugar snap peas, wax beans, globe or French artichokes, and water chestnuts")]), _vm._v(" "), _c('p', {
    staticClass: "ulist"
  }, [_vm._v("– berries (blackberries, blueberries, strawberries, raspberries, cranberries, mulberries, etc.), rhubarb, and olives")]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('h5', {
    staticClass: "h5"
  }, [_vm._v("Grain-Fed Animal Sources and Dairy")]), _vm._v(" "), _c('p', {
    staticClass: "ulist"
  }, [_vm._v("– beef, poultry, eggs, and ghee")])]), _vm._v(" "), _c('p', {
    staticClass: "ulist"
  }, [_vm._v("– dairy products (plain full-fat yogurt, cottage cheese, cream, sour cream, and cheese): Avoid products labeled “low-fat,” as most are packed with sugar and starch and have little satiating effect.")]), _vm._v(" "), _c('p', {
    staticClass: "ulist"
  }, [_vm._v("– bacon: Beware of preservatives and added starches.")]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('h5', {
    staticClass: "h5"
  }, [_vm._v("Nuts and Seeds")]), _vm._v(" "), _c('p', {
    staticClass: "ulist"
  }, [_vm._v("– pecans, almonds, walnuts, hazelnuts, pine nuts, flaxseed, pumpkin seeds, sesame seeds, sunflower seeds, and hemp seeds")])]), _vm._v(" "), _c('p', {
    staticClass: "ulist"
  }, [_vm._v("– brazil nuts (avoid overeating, due to their high selenium levels)")]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('h5', {
    staticClass: "h5"
  }, [_vm._v("Fermented Soy Products")]), _vm._v(" "), _c('p', {
    staticClass: "ulist"
  }, [_vm._v("– non-GMO, fermented soy products only (natto, tempeh, soy sauce, or paleo-friendly coconut aminos)")])]), _vm._v(" "), _c('p', {
    staticClass: "ulist"
  }, [_vm._v("– edamame (green soy beans) and black soybeans—unprocessed")]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('h5', {
    staticClass: "h5"
  }, [_vm._v("Condiments")]), _vm._v(" "), _c('p', {
    staticClass: "ulist"
  }, [_vm._v("– healthy “zero-carb” sweeteners (stevia, Swerve, erythritol, etc.)")])]), _vm._v(" "), _c('p', {
    staticClass: "ulist"
  }, [_vm._v("– thickeners: arrowroot powder, xanthan gum (technically, xanthan gum isn’t paleo-friendly, but some people following the paleo diet use it since most recipes only call for a very small amount)")]), _vm._v(" "), _c('p', {
    staticClass: "ulist"
  }, [_vm._v("– sugar-free tomato products (puree, pasta sauce, and ketchup)")]), _vm._v(" "), _c('p', {
    staticClass: "ulist"
  }, [_vm._v("– cacao and carob powder, extra dark chocolate (more than 70% cocoa: 90% is better), and cacao powder")]), _vm._v(" "), _c('p', {
    staticClass: "ulist"
  }, [_vm._v("– Beware of “sugar-free” chewing gums and mints which contain carbs.")]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('h5', {
    staticClass: "h5"
  }, [_vm._v("Some Vegetables, Fruits, Nuts, and Seeds with Average Carbohydrates")]), _vm._v(" "), _c('p', {
    staticClass: "ulist"
  }, [_vm._v("– root vegetables (celery root, carrot, beetroot, parsnip, and sweet potato)")])]), _vm._v(" "), _c('p', {
    staticClass: "ulist"
  }, [_vm._v("– apricot, watermelon, cantaloupe/galia/honeydew melons, dragon fruit (pitaya), peach, nectarine, apple, grapefruit, kiwifruit, kiwi berries, orange, plums, cherries, pears, and figs (fresh)")]), _vm._v(" "), _c('p', {
    staticClass: "ulist"
  }, [_vm._v("– dried fruit (dates, berries, raisins, figs, etc.)—only in very small quantities (if any)")]), _vm._v(" "), _c('p', {
    staticClass: "ulist"
  }, [_vm._v("– pistachio and cashew nuts and chestnuts")]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('h5', {
    staticClass: "h5"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_15"
    }
  }, [_vm._v("Alcohol")])]), _vm._v(" "), _c('p', {
    staticClass: "ulist"
  }, [_vm._v("– dry red wine, dry white wine, and spirits (unsweetened): avoid for weight loss and use only during weight maintenance")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('h4', {
    staticClass: "h4"
  }, [_vm._v("Avoid Completely")]), _vm._v(" "), _c('h5', {
    staticClass: "h5a"
  }, [_vm._v("Food Rich in Carbohydrates, Factory-Farmed Meat, and Processed Foods")]), _vm._v(" "), _c('p', {
    staticClass: "ulist"
  }, [_vm._v("– all grains, even whole meal (wheat, rye, oats, corn, barley, millet, bulgur, sorghum, rice, amaranth, buckwheat, and sprouted grains), quinoa, and potatoes: This includes all products made from grains (pasta, bread, pizza, cookies, crackers, etc.).")])]), _vm._v(" "), _c('p', {
    staticClass: "ulist"
  }, [_vm._v("– sugar and sweets (table sugar, high-fructose corn syrup, agave syrup, ice creams, cakes, sweet puddings, and sugary soft-drinks)")]), _vm._v(" "), _c('p', {
    staticClass: "ulist"
  }, [_vm._v("– factory-farmed pork and fish, which are high in inflammatory omega-6 fatty acids: farmed fish may contain polychlorinated biphenyls (PCBs)")]), _vm._v(" "), _c('p', {
    staticClass: "ulist"
  }, [_vm._v("– fish that are high in mercury (swordfish, king mackerel, shark, etc.)")]), _vm._v(" "), _c('p', {
    staticClass: "ulist"
  }, [_vm._v("– processed foods containing carrageenan (e.g., almond milk products), MSG (e.g., some whey protein products), sulphites (e.g., dried fruits, gelatin), or PCBs (e.g., in some farmed fish): They don’t always appear on the label!")]), _vm._v(" "), _c('p', {
    staticClass: "ulist"
  }, [_vm._v("– artificial sweeteners (Splenda, Equal, sweeteners containing aspartame, acesulfame, sucralose, saccharin, etc.)")]), _vm._v(" "), _c('p', {
    staticClass: "ulist"
  }, [_vm._v("– refined fats/oils (e.g., sunflower, safflower, cottonseed, canola, soybean, grapeseed, and corn oil) and trans fats such as margarine")]), _vm._v(" "), _c('p', {
    staticClass: "ulist"
  }, [_vm._v("– “low-fat,” “low-carb,” and “zero-carb” products (Atkins products, diet soda and drinks, chewing gums, and mints may be high in carbs or contain artificial additives, gluten, etc.)")]), _vm._v(" "), _c('p', {
    staticClass: "ulist"
  }, [_vm._v("– milk (only small amounts of raw, full-fat milk is allowed. Milk is not recommended for several reasons. Of all dairy products, milk is most difficult to digest, as it lacks the “good” bacteria—eliminated through pasteurization—and may even contain hormones, and it is quite high in carbs [4 to 5 grams of carbs per 100 ml]. For coffee and tea, replace milk with cream in reasonable amounts. You may have a small amount of raw milk, but be aware of the extra carbs.)")]), _vm._v(" "), _c('p', {
    staticClass: "ulist"
  }, [_vm._v("– alcoholic and sweet drinks (beer, sweet wine, cocktails, etc.), apart from small amounts of spirits and dry wine")]), _vm._v(" "), _c('p', {
    staticClass: "ulist"
  }, [_vm._v("– tropical fruit (pineapple, mango, banana, papaya, etc.) and some high-carb fruit (tangerine, grapes, etc.). Avoid fruit juices (yes, even 100% fresh juices!); smoothies are better, since they have fiber, but they too should be limited. This also includes dried fruit (dates, raisins, etc.) if eaten in large quantities.")]), _vm._v(" "), _c('p', {
    staticClass: "ulist"
  }, [_vm._v("– Soy products, apart from a few non-GMO fermented products that are known for their health benefits")]), _vm._v(" "), _c('p', {
    staticClass: "ulist"
  }, [_vm._v("– Wheat gluten, which may be used in some low-carb foods")]), _vm._v(" "), _c('p', {
    staticClass: "ulist"
  }, [_vm._v("– Products containing BPA: Beware of BPA-lined cans. If possible, use naturally BPA-free packaging, like glass jars, or make your own ingredients, such as ghee, ketchup, coconut milk, or mayonnaise. BPA has been linked to many negative health effects, such as impaired thyroid function and cancer.")]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('h4', {
    staticClass: "h4"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_16"
    }
  }, [_vm._v("Suitable Low-Carb Sweeteners")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Figuring out which sweeteners are appropriate for a ketogenic or other low-carb diet can be confusing. First of all, avoiding sugar completely is critical for succeeding at the ketogenic lifestyle. Second, not all sweeteners are suitable for a low-carb diet, and not all low-carb sweeteners are healthy.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("So what about “healthy” sweeteners? Raw honey, blackstrap molasses, date syrup, rice malt syrup, maple syrup, or coconut palm sugar are often recommended on a paleo diet. However, if your aim is to lose weight, you should avoid them. Sugar is sugar. No matter how healthy the sweetener is, it will always impair your weight loss and can potentially kick you out of ketosis. Here’s a list of the best keto-friendly sweeteners:")]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('h4', {
    staticClass: "h4"
  }, [_vm._v("Stevia")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Stevia is one of the best low-carb sweeteners, and it’s my personal favorite. The extract is made from the herb stevia, and it has no calories and no effect on blood sugar. I use stevia drops for the recipes in this book, but you can use powdered stevia instead. The sweetness of products containing stevia varies, so you’ll have to adjust them to your palate: keep in mind that stevia drops are about 200 to 300 times sweeter than sugar. And remember that too much stevia will make the final result bitter, so combine stevia with erythritol or Swerve to avoid any unpleasant aftertaste. (As always, make sure you avoid sweeteners with added sugar, dextrose, and maltodextrin, which will spike your blood sugar levels.)")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('h4', {
    staticClass: "h4"
  }, [_vm._v("Erythritol and Swerve")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Erythritol is naturally found in fruits, vegetables, and fermented foods. It is a sugar alcohol that does not affect blood glucose and has very few calories. Erythritol is commonly used in low-carb cooking, and it’s one of my favorites: I often combine it with liquid stevia. Some of the recipes in this book ask you to powder erythritol before mixing with other ingredients: that’s because erythritol remains grainy unless it’s heated. Swerve is an erythritol-based sweetener that is great for low-carb baking.")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('h4', {
    staticClass: "h4"
  }, [_vm._v("Monk Fruit Powder")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("This sweetener is also known as lo han or luo han. It’s as sweet as stevia, but without the bitter aftertaste of most stevia products. Sweeteners containing monk fruit extract may contain other ingredients: keep that in mind and avoid any sweeteners with added sugar, artificial sweeteners, dextrose, or maltodextrin.")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('h4', {
    staticClass: "h4"
  }, [_vm._v("Xylitol")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Xylitol is a sugar alcohol that naturally occurs in the fibers of certain fruits and vegetables. It’s a sugar substitute that tastes like sugar but has fewer calories. Xylitol has a glycemic index of 13 and has 3 calories per gram. It does not affect blood sugar significantly if consumed in moderation. However, Xylitol may cause digestive issues in some people, especially if you eat more than 50 grams.")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('h4', {
    staticClass: "h4"
  }, [_vm._v("Inulin-Based Sweeteners")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Chicory root inulin (chicory root fiber) is probably the most popular inulin-based sweetener. Inulin has been shown to have health-promoting prebiotic effects. Some of the inulin-type prebiotics are called fructooligosaccharides (FOS), which are a type of carbohydrate that our bodies cannot fully digest. Consumption of FOS does not increase blood sugar.")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('h4', {
    staticClass: "h4"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_17"
    }
  }, [_vm._v("Yacon Syrup")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Yacon syrup has a slightly caramel taste and is similar to blackstrap molasses and coconut palm sugar. It consists of 50% FOS and a fiber called inulin that doesn’t increase blood sugar. However, because it does have a small effect on blood sugar, you should use it very sparingly.")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('h4', {
    staticClass: "h4"
  }, [_vm._v("Sweeteners to Avoid")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Avoid all sweeteners containing carbs, such as table sugar, high-fructose corn syrup, and agave syrup. Agave syrup may be sold as a “health” food, but the truth is, it’s loaded with unhealthy fructose. Artificial sweeteners like aspartame, saccharin, sucralose, or acesulfame K may seem like an ideal option while following a healthy low-carb diet, but you should avoid them: Not only do they cause sugar cravings, but regular consumption of them is also linked to several negative health effects such as bloating, migraines, and weight gain. Some are even linked to certain types of cancer.")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('h4', {
    staticClass: "h4"
  }, [_vm._v("Cooking Ketogenic")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("When you’re sourcing ingredients, try to get them in their most natural forms: that is, organically-grown and free from unnecessary additives. Buy organic eggs; organic unwaxed lemons; pastured beef and butter; outdoor-reared pork; wild-caught fish; and extra virgin coconut oil.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Remember:")]), _vm._v(" "), _c('p', {
    staticClass: "ulistb"
  }, [_vm._v("• All the recipes in this book are well-suited to the ketogenic, paleo, and primal diets. Additionally, several recipes include dairy-free options.")]), _vm._v(" "), _c('p', {
    staticClass: "ulistb"
  }, [_vm._v("• Nutrition values for each recipe are per serving unless stated otherwise. The nutrition data are derived from the USDA National Nutrient Database ("), _c('a', {
    attrs: {
      "href": "http://ndb.nal.usda.gov",
      "target": "_blank"
    }
  }, [_vm._v("http://ndb.nal.usda.gov")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "ulistb"
  }, [_vm._v("• Nutrition facts are calculated from edible parts. For example, if one avocado is listed as 200 g/7.1 oz, this value represents its edible parts (seeds and peel removed) unless otherwise specified.")]), _vm._v(" "), _c('p', {
    staticClass: "ulistb"
  }, [_vm._v("• Optional ingredients and suggestions are not included in the nutrition information.")]), _vm._v(" "), _c('div', {
    staticClass: "sidebar"
  }, [_c('p', {
    staticClass: "stitle"
  }, [_vm._v("AN IMPORTANT NOTE ABOUT MEASUREMENTS")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("If you are following a ketogenic diet for specific health reasons, you should be aware that accuracy is vital for this diet to work. When measuring ingredients, always weigh them using a kitchen scale. Using measures like cups or tablespoons can lead to inaccuracies that may impact the macronutrient composition of your meal. All it takes to shift your body out of ketosis is a few extra grams of carbohydrates. Furthermore, cups and tablespoons for dried products (psyllium, flax meal, etc.) may vary depending on the brand. Using a less-than-precise amount of an ingredient will affect the quality of a recipe—particularly for baked goods—and the final result will be less than desirable.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c1c385f8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch01.vue
// module id = 69
// module chunks = 0